import { useState, useEffect } from "react";
import { Location } from "history";
import serialize, { deserialize } from "../../utils/serialize";
import { FormattedMessage } from "react-intl";
import { User } from "firebase/auth";

import styles from "./styles.module.css";
//import "./login.css";

import Auth from "../../api/auth";
import { setAuth } from "../../utils/localStorage";
import { useAppStore } from "../../store/app";
import GoogleAuthButton from "../../components/common/google-auth";
import PasswordAuth from "../../components/common/password-auth";
import Divider from "./Divider";
// import MicrosoftAuthButton from "../../components/common/microsoft-auth";

const Login: React.FC<ILayoutProps> = (props: ILayoutProps) => {
  const [logInError, setLogInError] = useState(null);
  const [registerLink, setRegisterLInk] = useState("");
  const [loading, setLoading] = useState(false);

  const setAppUser = useAppStore((state) => state.setAppUser);

  useEffect(() => {
    const { search } = props.location;
    const queryObject = deserialize(search);

    if (queryObject.code && queryObject.pathname === "/cloudbeds") {
      const queryString = serialize(queryObject);
      setRegisterLInk(`/auth/register-cloudbeds?pathname=/&${queryString}`);
    } else {
      setRegisterLInk(`/auth/register${search}`);
    }
  }, [props.location]);

  const loginApi = async (auth: User) => {
    setLoading(() => true);
    const hash = await auth.getIdToken();
    const { err } = await Auth.login({ hash });
    if (err) {
      setLogInError(() => err.message);
    }
    setLoading(() => false);
  };

  return (
    <div className={styles.authHolder}>
      <div className={styles.authPanel}>
        <h1>
          {" "}
          <FormattedMessage id="auth.login.title" />
        </h1>

        <div className="flex flex-column gap-3">
          <GoogleAuthButton type="sign-in" onSuccess={loginApi} />
          {/*
          <MicrosoftAuthButton
            type="sign-in"
            onSuccess={loginApi}
          />
          */}
        </div>

        <Divider />

        <PasswordAuth
          type="sign-in"
          registerLink={registerLink}
          onSuccess={loginApi}
          loading={loading}
          error={logInError}
        />
      </div>
    </div>
  );
};

interface ILayoutProps {
  location: Location;
}

export default Login;
